import React from "react";

import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

import FilterArrow from 'shared-vectors/icons/FilterArrow';
import FilterArrowDsk from 'shared-vectors/icons/FilterArrowDsk';
import { Icon } from 'shared-vectors';

import { getMainLocalityText, getButtonText } from '@helpers/localityDisplay';

function Locations({ tempLocationsQB, filters, isMobile, action}) {
  return (
    <Grid role="button" className="cnt-loc-srh__mb mb--m b--s" noWrap onClick={action}>
      <GridItem behavior="fixed" className="p--ms tp-s--m tp-w--m">
        {getMainLocalityText({
          mainLoc: tempLocationsQB?.uiLocations?.main,
          qExpansion: filters?.qExpansion || '0',
          hasChildrenLocality: tempLocationsQB?.uiLocations?.additional?.length > 0,
          showPreposition: false,
          isQBLocalitySearch: true,
        })}
        {getButtonText({
          mainLevel: tempLocationsQB?.uiLocations?.main?.level,
          children: tempLocationsQB?.uiLocations?.additional || [],
          qExpansion: filters?.qExpansion || '0',
          isQBLocalitySearch: true,
        })}
      </GridItem>
      <GridItem behavior="fixed" push="left" aria-hidden="true" className="p--ms">
        <Grid align="center" className="cnt-loc-srh">
          <Icon
            name={isMobile ? FilterArrow : FilterArrowDsk}
            width={isMobile ? '14px' : '16px'}
            height={isMobile ? '8px' : '16px'}
            className="rotate--270"
            fill={isMobile}
          />
        </Grid>
      </GridItem>
    </Grid>
  );
}

export default Locations;
